export const isBiggestPosOrNeg = (optionsCellData, index) => {
  if (!optionsCellData || optionsCellData.length === 0) return false;

  // Convert values to numbers and determine the maximum absolute value
  const absValues = optionsCellData.map((item) => ({
    index: item.index,
    value:
      typeof item.value === "string"
        ? parseFloat(item.value.replace("%", ""))
        : item.value,
  }));

  const maxAbsValue = Math.max(
    ...absValues.map((item) => Math.abs(item.value))
  );

  // Filter items that have the maximum absolute value
  const maxItems = absValues.filter(
    (item) => Math.abs(item.value) === maxAbsValue
  );

  // Return true only if there's exactly one item with the max absolute value and its index matches
  return maxItems.length === 1 && maxItems[0].index === index;
};

export const isSmallestPosOrNeg = (optionsCellData, index) => {
  if (!optionsCellData || optionsCellData.length === 0) return false;

  // Convert values to numbers and determine the minimum absolute value
  const absValues = optionsCellData.map((item) => ({
    index: item.index,
    value:
      typeof item.value === "string"
        ? parseFloat(item.value.replace("%", ""))
        : item.value,
  }));

  const minAbsValue = Math.min(
    ...absValues.map((item) => Math.abs(item.value))
  );

  // Filter items that have the minimum absolute value
  const minItems = absValues.filter(
    (item) => Math.abs(item.value) === minAbsValue
  );

  // Return true only if there's exactly one item with the min absolute value and its index matches
  return minItems.length === 1 && minItems[0].index === index;
};

export const mostlyPositive = (optionsCellData) => {
  if (!optionsCellData || optionsCellData.length === 0) return false;

  // Count the number of positive and negative values in optionsCellData
  let positiveCount = 0;
  let negativeCount = 0;

  optionsCellData.forEach((item) => {
    const value =
      typeof item.value === "string"
        ? parseFloat(item.value.replace("%", ""))
        : item.value;
    if (value > 0) positiveCount += 1;
    if (value < 0) negativeCount += 1;
  });

  // Return true if positive values are more than negative values
  return positiveCount > negativeCount;
};

export const mostlyNegative = (optionsCellData) => {
  if (!optionsCellData || optionsCellData.length === 0) return false;

  // Count the number of positive and negative values in optionsCellData
  let positiveCount = 0;
  let negativeCount = 0;

  optionsCellData.forEach((item) => {
    const value =
      typeof item.value === "string"
        ? parseFloat(item.value.replace("%", ""))
        : item.value;
    if (value > 0) positiveCount += 1;
    if (value < 0) negativeCount += 1;
  });

  // Return true if negative values are more than positive values
  return negativeCount > positiveCount;
};

export const histRangeMatch = (optionPlotRange, actualPlotRange) => {
  if (!optionPlotRange || !actualPlotRange) return false;
  if (
    optionPlotRange.min == actualPlotRange.min &&
    optionPlotRange.max == actualPlotRange.max
  )
    return true;
  return false;
};

export const histBinWidthMatch = (optionBinWidth, actualBinWidth) => {
  if (!optionBinWidth || !actualBinWidth) return false;
  if (optionBinWidth == actualBinWidth) return true;
  return false;
};
